var _rect, _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDresezIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 130,
    ry: 130,
    fill: "#3a6df0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.35, 63.82) scale(2.1176470588235294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92 56 L 92 38 Q 92 22 78 22 Q 64 22 64 32",
    stroke: "#ffffff",
    strokeWidth: 11,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 112,
    r: 44,
    stroke: "#ffffff",
    strokeWidth: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 56,
    width: 18,
    height: 100,
    rx: 2,
    fill: "#ffffff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 60,
    r: 19,
    fill: "#fde66a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDresezIcon);
export default __webpack_public_path__ + "static/media/dresez-icon.4e1c1d61bfd37215ee7b4bc3eb219971.svg";
export { ForwardRef as ReactComponent };